import React, { useEffect } from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AccountAuth from "@/pages/AccountAuth";
import Account from "@/pages/Account";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Cinc from "@/pages/cinc/Cinc";
import CincAdmin from "@/pages/cinc/CincAdmin";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const StoreLayout = ({ children }) => (
  <>
    <Header />
    <CartDrawer />
    <main>{children}</main>
    <Footer />
  </>
);

// When the site is opened via the CiNC domain (e.g. cincstock.in), serve the
// CiNC tool at the root. Any other host serves the TAMASHii fashion site.
const isCincHost = typeof window !== "undefined" && /cincstock/i.test(window.location.hostname);

function CincApp() {
  return (
    <BrowserRouter>
      <ScrollTop />
      <Routes>
        <Route path="/" element={<Cinc />} />
        <Route path="/admin" element={<CincAdmin />} />
        <Route path="/cinc" element={<Cinc />} />
        <Route path="/cinc/admin" element={<CincAdmin />} />
        <Route path="*" element={<Cinc />} />
      </Routes>
    </BrowserRouter>
  );
}

function App() {
  if (isCincHost) return <CincApp />;
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App bg-[#0A0A0C] min-h-screen">
        <div className="grain" />
        <BrowserRouter>
          <ScrollTop />
          <CartProvider>
            <AuthProvider>
              <Toaster theme="dark" position="bottom-right" />
              <Routes>
                <Route path="/" element={<StoreLayout><Home /></StoreLayout>} />
                <Route path="/shop" element={<StoreLayout><Shop /></StoreLayout>} />
                <Route path="/product/:id" element={<StoreLayout><ProductDetail /></StoreLayout>} />
                <Route path="/cart" element={<StoreLayout><Cart /></StoreLayout>} />
                <Route path="/payment/success" element={<StoreLayout><PaymentSuccess /></StoreLayout>} />
                <Route path="/account" element={<StoreLayout><Account /></StoreLayout>} />
                <Route path="/account/login" element={<StoreLayout><AccountAuth /></StoreLayout>} />
                <Route path="/account/register" element={<StoreLayout><AccountAuth /></StoreLayout>} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/cinc" element={<Cinc />} />
                <Route path="/cinc/admin" element={<CincAdmin />} />
              </Routes>
            </AuthProvider>
          </CartProvider>
        </BrowserRouter>
      </div>
    </ReactLenis>
  );
}

export default App;
